<template>
  <div class="featureauswahl" :class="{desktop:version==='desktop'}">
    <div v-for="feature in features" v-bind:key="feature.Feature" class="feature-content" @click="$emit('changefeature', feature)">
      <div class="feature-img-wrapper">
        <img :src="imageUrl(feature.detailImageURL)" class="feature-img" :alt="feature.Name">
      </div>
      <div class="feature-text">
        <input v-if="!is_unchoosableFeature(feature.Feature)"
               type="radio"
               :checked="is_selected(feature.Name)"
               :name="foname"
               :value="feature.Feature"

        >
        <label>{{ feature.Name }}</label>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import {computed} from "vue";
import {
  insertCloudflareAutoformatIntoURLForStaticCDNURL,
  insertCloudflareDownscalingIntoURLForStaticCDNURL
} from "@k/global/globalUtils";

const props = defineProps(
    {
      features: Array,
      foname: String,
      selected_features: Array,
      version: String
    }
);
const emit = defineEmits(['changefeature']);

const imageUrl = (detailImageURL: string) => {
  detailImageURL = "https://static.owayo-cdn.com/" + detailImageURL.replace("/owayo/", "");
  return insertCloudflareDownscalingIntoURLForStaticCDNURL(detailImageURL, 200, 200)
};

const is_selected = computed(()=>featurename => props.selected_features!.indexOf(featurename) > -1);
const is_unchoosableFeature = featureName => featureName === 'banner_variable_abmessungen';

</script>

<style scoped lang="scss">
.featureauswahl {
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 40px;
  justify-content: space-evenly;

  .feature-content {
    width: 200px;
    margin-right: 20px;
    margin-bottom: 30px;
    display: flex;
    flex-direction: column;
    align-items: center;
    .feature-img-wrapper {
      background: #FFF;
      margin-right: 20px;
      margin-bottom: 5px;
    }

    .feature-img {

    }

    .feature-text {
      label {
        font-size: 12px;
        line-height: 1.35em;
        font-weight: 600;
      }
    }
  }

  &.desktop {
    .feature-content {

      .feature-img-wrapper {
        width: 160px;
        height: 160px;
        /*display: flex;*/
        /*padding: 8px;*/
      }

      .feature-img {
        width: auto;
      }
    }
  }
}
</style>
